type QuillOp = { insert?: unknown; attributes?: unknown };
type QuillDelta = { ops: QuillOp[] };

const STREAMING_URL = 'wss://streaming.eu.assemblyai.com/v3/ws';
const SPEECH_MODEL = 'universal-3-6-pro';

export function isEmptyAnswer(delta?: QuillDelta | null): boolean {
	if (!delta?.ops?.length) {
		return true;
	}

	return delta.ops.every((op) => typeof op.insert !== 'string' || op.insert.trim() === '');
}

/** Adds the transcript as the whole answer, or as a following paragraph. */
export function appendTranscript(
	delta: QuillDelta | null | undefined,
	transcript: string,
): QuillDelta {
	const text = transcript.trim();
	if (!text) {
		return delta?.ops ? delta : { ops: [{ insert: '\n' }] };
	}

	if (isEmptyAnswer(delta)) {
		return { ops: [{ insert: `${text}\n` }] };
	}

	return { ops: [...(delta?.ops ?? []), { insert: `${text}\n` }] };
}

export function feedbackStreamingUrl(input: {
	token: string;
	language: string;
	encodingParams?: Record<string, string>;
}): string {
	const params = new URLSearchParams({
		token: input.token,
		speech_model: SPEECH_MODEL,
		speaker_labels: 'true',
		max_speakers: '1',
		language_codes: JSON.stringify([input.language]),
		...(input.encodingParams ?? {}),
	});

	return `${STREAMING_URL}?${params.toString()}`;
}
